import styled from 'styled-components'

export const CreateForm = styled.div`
  position: relative;
  margin-top: 0rem;
  padding: 2rem;
  background: var(--color-white);
  border-radius: 10px;
`

export const IconWrap = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 2rem;
  cursor: pointer;
`
